export default {
  root: {
    margin: 0,
    paddingLeft: 0,
    paddingRight: 0,
    height: '100px'
  }
};
